function pad(num) {
    if (num.toString().length == 1) {
        return `0${num}`
    }
    return num
}

function printDate(stringDate) {
    if (stringDate) {
        const date = new Date(stringDate)
        if (typeof date.getDate() === 'number' && typeof (date.getMonth() + 1) === 'number' && typeof date.getFullYear() === 'number') {
            return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`
        }
    }
    return ''
}

export function detailedTime(activities) {
    let hTotal = 0
    let mTotal = 0

    if (activities && activities.length > 0) {
        for (let index = 0; index < activities.length; index++) {
            const act = activities[index];

            if (typeof act.time == 'string') {

                let timeAux = act.time.split(":")
                mTotal = mTotal + parseInt(timeAux[1])
                hTotal = hTotal + parseInt(timeAux[0])

                if (mTotal > 59) {
                    mTotal = mTotal - 60
                    hTotal++
                }
            } else {
                const timeStr = act.time.toString();
                if (timeStr.length === 1) {
                    mTotal +=  parseInt(timeStr.slice(0, 1))
                } else if (timeStr.length === 2) {
                    if (timeStr === "60") {
                        hTotal++
                    } else {
                        mTotal +=  parseInt(timeStr.slice(0, 2))
                    }
                } else if (timeStr.length === 3) {
                    hTotal +=  parseInt(timeStr.slice(0,1))
                    mTotal +=  parseInt(timeStr.slice(1,3))
                } else if (timeStr.length === 4) {
                    hTotal +=  parseInt(timeStr.slice(0,2))
                    mTotal +=  parseInt(timeStr.slice(2,4))
                }
            }
        }
    }

    return {hours: hTotal < 10 ? `0${hTotal.toString()}`: hTotal, minutes: mTotal < 10 ? `0${mTotal.toString()}`: mTotal };
}

export function cutTime(item) {
    if (typeof item.time == 'string') {
        return item.time
    } else if (typeof item.time == 'number') {
        const timeStr = item.time.toString();
        if (timeStr.length === 1) {
            return "00:0" + timeStr.slice(0, 1)
        } else if (timeStr.length === 2) {
            if (timeStr === "60") {
                return "01:00"
            } else {
                return "00:" + timeStr.slice(0, 2)
            }
        } else if (timeStr.length === 3) {
            return "0" + timeStr.slice(0, 1) + ":" + timeStr.slice(1, 3)
        } else if (timeStr.length === 4) {
            return timeStr.slice(0, 2) + ":" + timeStr.slice(2, 4)
        }
    }
}

export function parseTimeObjectToMinutes(time) {
    return parseInt(time.minutes) + (parseInt(time.hours) * 60);

}

export function transformDate(item) {
    if (!item || item === '') {
        return ''
    }

    const data = item.split("-");
    return `${data[2]}-${data[1]}-${data[0]}`;
}


function processInline(el) {
    const inlineTags = { b: 'strong', i: 'em', strong: 'strong', em: 'em', u: 'u', a: 'a' };
    let html = '';
    for (let i = 0; i < el.childNodes.length; i++) {
        const child = el.childNodes[i];
        if (child.nodeType === Node.TEXT_NODE) {
            html += child.textContent;
        } else if (child.nodeType === Node.ELEMENT_NODE) {
            const tag = child.tagName.toLowerCase();
            let colorStyle = '';
            if (child.style && child.style.color) {
                colorStyle = `color: ${child.style.color}`;
            } else if (child.getAttribute('color')) {
                colorStyle = `color: ${child.getAttribute('color')}`;
            }
            let content = processInline(child);
            if (colorStyle) {
                content = `<span style="${colorStyle}">${content}</span>`;
            }

            if (tag === 'br') {
                html += '<br>';
            } else if (inlineTags[tag]) {
                const finalTag = inlineTags[tag];
                if (tag === 'a' && child.href) {
                     html += `<a href="${child.href}"${colorStyle ? ` style="${colorStyle}"` : ''}>${content}</a>`;
                } else {
                     html += `<${finalTag}>${content}</${finalTag}>`;
                }
            } else {
                html += content;
            }
        }
    }
    return html;
}

function extractBlocks(el, blocks) {
    for (let i = 0; i < el.childNodes.length; i++) {
        const node = el.childNodes[i];
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();
            if (text) blocks.push(`<div>${text}</div>`);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const tag = node.tagName.toLowerCase();

            if (tag === 'br') {
                blocks.push('<br>');
            } else if (tag === 'div' || tag === 'p') {
                const hasBlocks = Array.from(node.children).some(c => 
                    ['div', 'p'].includes(c.tagName.toLowerCase())
                );

                if (hasBlocks) {
                    extractBlocks(node, blocks);
                } else {
                    const content = processInline(node).trim();
                    if (content) blocks.push(`<div>${content}</div>`);
                }
            } else {
                extractBlocks(node, blocks);
            }
        }
    }
}

function cleanComplexHTML(htmlString) {
    if (!htmlString || typeof htmlString !== 'string') return htmlString;

    const decoder = document.createElement('textarea');
    decoder.innerHTML = htmlString;

    const container = document.createElement('div');
    container.innerHTML = decoder.value;

    const blocks = [];

    extractBlocks(container, blocks);
    return blocks.join('') || htmlString;
}

export {pad, printDate, cleanComplexHTML}
